import { useEffect, useState } from 'react'
import {Activity, Menu, X} from 'lucide-react'

const LINKS = [
  { href: '#calculator', label: 'Calculator' },
  { href: '#meals', label: 'Meal Planner' },
  { href: '#workout', label: 'Workout' },
  { href: '#guide', label: 'Guide' },
  { href: '#faq', label: 'FAQ' },
]

function Navbar() {
  const [scrolled, setScrolled] = useState(false)
  const [open, setOpen] = useState(false)

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12)
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-[#0a0c10]/85 backdrop-blur-xl border-b border-white/[0.06]'
          : 'bg-transparent border-b border-transparent'
      }`}
    >
      <nav className="max-w-7xl mx-auto px-5 sm:px-8 h-[72px] flex items-center justify-between">
        <a href="#top" className="flex items-center gap-2.5 group" aria-label="ShredCalculator home">
          <span className="grid place-items-center w-9 h-9 rounded-xl bg-blue-600 shadow-[0_0_20px_rgba(37,99,235,0.5)]">
            <Activity className="w-5 h-5 text-white" aria-hidden="true" />
          </span>
          <span className="font-display font-bold text-[17px] tracking-tight text-white">
            Shred<span className="text-blue-500">Calculator</span>
          </span>
        </a>

        <div className="hidden md:flex items-center gap-8">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="text-[14px] font-medium text-slate-400 hover:text-white transition-colors"
            >
              {l.label}
            </a>
          ))}
        </div>

        <div className="hidden md:block">
          <a
            href="#calculator"
            className="inline-flex items-center rounded-full bg-white text-[#0a0c10] px-5 py-2.5 text-[14px] font-semibold hover:bg-blue-500 hover:text-white transition-colors"
          >
            Get Ripped Now
          </a>
        </div>

        <button
          className="md:hidden text-white p-2"
          onClick={() => setOpen((o) => !o)}
          aria-label={open ? 'Close menu' : 'Open menu'}
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </nav>

      {open && (
        <div className="md:hidden bg-[#0a0c10]/95 backdrop-blur-xl border-b border-white/[0.06] px-5 py-4 space-y-1">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="block py-2.5 text-[15px] font-medium text-slate-300 hover:text-white"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#calculator"
            onClick={() => setOpen(false)}
            className="block mt-3 text-center rounded-full bg-blue-600 text-white px-5 py-3 text-[15px] font-semibold"
          >
            Get Ripped Now
          </a>
        </div>
      )}
    </header>
  )
}

export default Navbar
